import BasicRoute from "components/routes/BasicRoute"
import Mapa from "entity/Mapa";

export default function RoutesMenusMapa() {

    return <>
        <BasicRoute
            perfilAuth={['r9jrEQXznNgjrZTGCfch']} //admin
            uid="mapa"
            route="mapa"

            menuProps={{
                text: "Mapa",
                sequence: "111111",
                iconName: 'Map',
            }}

            element={<Mapa />}
        />
    </>;
}
